import { render, staticRenderFns } from "./cancelledorder.vue?vue&type=template&id=62042350&scoped=true&"
import script from "./cancelledorder.vue?vue&type=script&lang=js&"
export * from "./cancelledorder.vue?vue&type=script&lang=js&"
import style0 from "./cancelledorder.vue?vue&type=style&index=0&id=62042350&lang=less&scoped=true&"
import style1 from "./cancelledorder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62042350",
  null
  
)

export default component.exports